import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "offcanvas-header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "offcanvas-body" }
const _hoisted_4 = { class: "mobile-menu" }
const _hoisted_5 = { class: "mobile-menu-list without-icon" }
const _hoisted_6 = {
  key: 0,
  class: "mobile-menu-list without-icon"
}
const _hoisted_7 = { class: "mobile-menu-list without-icon" }
const _hoisted_8 = { class: "mobile-menu-list without-icon" }
const _hoisted_9 = { class: "mobile-menu-list without-icon" }
const _hoisted_10 = {
  key: 2,
  class: "mobile-menu-list without-icon"
}
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'mobile-navbar offcanvas offcanvas-end border-0',
      { show: _ctx.stateStoreInstance.navbar },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RouterLink, {
        to: "/",
        class: "logo d-inline-block",
        onClick: _ctx.closeNav
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.nav.logo_url || _ctx.defaultLogo,
            alt: "logo",
            style: {"max-height":"42px"}
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("button", {
        type: "button",
        class: "close-btn bg-transparent position-relative lh-1 p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeNav && _ctx.closeNav(...args)))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("i", { class: "ri-close-fill" }, null, -1)
      ]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleLinks, (link) => {
          return (_openBlock(), _createElementBlock("li", {
            key: link.url,
            class: "mobile-menu-list without-icon"
          }, [
            _createVNode(_component_RouterLink, {
              to: link.url,
              class: "nav-link",
              onClick: _ctx.closeNav
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(link.label), 1)
              ]),
              _: 2
            }, 1032, ["to", "onClick"])
          ]))
        }), 128)),
        (_ctx.authStore.isLoggedIn)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("li", _hoisted_5, [
                _createVNode(_component_RouterLink, {
                  to: "/dashboard",
                  class: "nav-link",
                  onClick: _ctx.closeNav
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("i", { class: "ti ti-user" }, null, -1),
                    _createTextVNode(" My Dashboard ")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]),
              (_ctx.authStore.isAdmin)
                ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                    _createVNode(_component_RouterLink, {
                      to: "/admin",
                      class: "nav-link",
                      onClick: _ctx.closeNav
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createElementVNode("i", { class: "ti ti-settings" }, null, -1),
                        _createTextVNode(" Admin Panel ")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_7, [
                _createElementVNode("a", {
                  href: "#",
                  class: "nav-link",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)), ["prevent"]))
                }, _cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "ti ti-logout" }, null, -1),
                  _createTextVNode(" Logout ")
                ]))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_RouterLink, {
                  to: "/login",
                  class: "nav-link",
                  onClick: _ctx.closeNav
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "ti ti-user" }, null, -1),
                    _createTextVNode(" Login ")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createVNode(_component_RouterLink, {
                  to: _ctx.nav.cta_url || '/register',
                  class: "nav-link",
                  onClick: _ctx.closeNav
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.nav.cta_text || 'Get Started'), 1)
                  ]),
                  _: 1
                }, 8, ["to", "onClick"])
              ])
            ], 64)),
        (_ctx.nav.phone)
          ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
              _createElementVNode("a", {
                href: 'tel:' + _ctx.nav.phone,
                class: "nav-link"
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ti ti-phone-incoming" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.nav.phone), 1)
              ], 8, _hoisted_11)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}